import { MediaItem } from "../Global/MediaItem/MediaItem";
import styles from "./RecipeCard.module.scss";
import { ImageType } from "@/types/baseTypes";
import { DifficultyBox } from "./DifficultyBox";
import { CardActionIcon } from "./CardActionIcon";
import { CardLikeButton } from "./CardLikeButton";
import { buildAbsoluteInternalLink } from "@/utils/url.ts";
import { CustomLink } from "@/components/Global/CustomLink.tsx";
import { CardTitle } from "./CardTitle";

export type RecipeElementType = {
  recipeId: number;
  isClickOut: boolean;
  title: string;
  difficultyLevel: {
    level: 0 | 1 | 2 | 3;
    label: string;
  };
  image: ImageType | false;
};

type RecipeCardProps = {
  recipe: RecipeElementType;
  htmlTag: 3 | 4;
  needsTotalLikeCount: boolean;
};

export const RecipeCard = ({
  recipe,
  htmlTag,
  needsTotalLikeCount,
}: RecipeCardProps) => {
  const { difficultyLevel, image, title, isClickOut, recipeId } = recipe;

  return (
    <div className={styles["card-container"]}>
      {image ? (
        <MediaItem
          image_desktop={image}
          sizes="(max-width: 768px) 70vw, 30vw"
          className={styles["card-image"]}
        />
      ) : (
        <div className={styles["card-image"]} />
      )}

      <div className={styles["overlay"]}>
        <div className={styles["top-left"]}>
          <CardTitle htmlTag={htmlTag} title={title} />
        </div>

        <div className={styles["top-right"]}>
          <CardLikeButton
            recipeId={recipeId}
            needsTotalLikeCount={needsTotalLikeCount}
            recipeTitle={title}
          />
        </div>

        <div className={styles["bottom-left"]}>
          <DifficultyBox
            difficultyLevel={difficultyLevel}
            isClickOut={isClickOut}
          />
        </div>

        <div className={`${styles["bottom-right"]} ${styles["action-button"]}`}>
          <CardActionIcon isClickOut={isClickOut} recipeId={recipeId} />
        </div>
      </div>

      <CustomLink
        className={styles["card-link"]}
        target={isClickOut ? "_blank" : "_self"}
        href={
          isClickOut
            ? `https://meintiptopf.ch/rezepte/${recipeId}`
            : buildAbsoluteInternalLink(`/rezepte/${recipeId}`)
        }
      ></CustomLink>
    </div>
  );
};
